// api.js
import service from '../config/index'

export function login(username, password) {
  return service.post('/login', { username, password })
}
//获取错误信息
export function getDataList(params) {
  return service({
    url: '/WebsiteContentValidate?baseDomain=' + params.baseDomain + '&articleId=' + params.articleId,
    method: 'get'
  });
}
//校验文本
export function verifyText(params) {
  return service({
    url: '/ValidateContent',
    method: 'post',
    data: params,
  });
}
//校对内容，通过通义千问AI审核
export function verifyTextByTYQW(params) {
  return service({
    url: '/ValidateContentByTYQW',
    method: 'post',
    data: params,
  });
}
//校对内容，通过通义千问AI审核
export function verifyTextByIJiaoDui(params) {
  return service({
    url: '/ValidateContentByIJiaoDui',
    method: 'post',
    data: params,
  });
}

